import OperationCanceledError from "../errors/operationCanceledError";

export default class CancellationToken {
    constructor() {
        this.isCanceled = false;
    }

    cancel() {
        this.isCanceled = true;
    }

    isCanceled() {
        return this.isCanceled;
    }

    throwIfCanceled() {
        if(this.isCanceled) {
            throw new OperationCanceledError("Operation is canceled");
        }
    }
}